import { useAuth } from 'react-oidc-context';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export const LogoutButton = () => {
  const auth = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await auth.removeUser();
      navigate('/login', { replace: true });
    } catch (error) {
      console.error('Logout error:', error);
      auth.removeUser();
      navigate('/login', { replace: true });
    }
  };

  return (
    <Button 
      onClick={handleLogout}
      variant="outlined"
      color="inherit"
      sx={{
        bgcolor: 'background.paper',
        borderColor: 'background.paper',
        fontSize: { xs: '0.75rem', sm: '0.875rem' },
        minWidth: { xs: '80px', sm: '100px' },
        height: { xs: '32px', sm: '36px' },
        whiteSpace: 'nowrap',
        color: 'primary.main', 
        '&:hover': {
          bgcolor: 'rgba(255, 255, 255, 0.9)',
          borderColor: 'background.paper'
        }
      }}
    >
      ログアウト
    </Button>
  );
};